export const envVarKeys = {
  NEXT_PUBLIC_ENABLE_WEBSDK: 'NEXT_PUBLIC_ENABLE_WEBSDK',
  NEXT_PUBLIC_GET_SESSION_ENDPOINT: 'NEXT_PUBLIC_GET_SESSION_ENDPOINT',
  NEXT_PUBLIC_UPDATE_SESSION_ENDPOINT: 'NEXT_PUBLIC_UPDATE_SESSION_ENDPOINT',
  NEXT_PUBLIC_GET_MVPOFFERS_ENDPOINT: 'NEXT_PUBLIC_GET_MVPOFFERS_ENDPOINT',
  NEXT_PUBLIC_ENABLE_DCA_V2: 'NEXT_PUBLIC_ENABLE_DCA_V2',
};
